export default "__VITE_ASSET__CbYX5I0K__"